module.exports = __webpack_public_path__ + "static/media/1015137.3af3da4f.jpg";